import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
// import { Loading } from 'element-ui'
import Login from '@/page/login/Login'
import Layout from '../layout/index'
import Home from '@/page/home/Home'
import SupplierSet from '@/page/supplierManage/SupplierSet'
import warehouseIntoAdd from '@/page/assignmentManage/warehouse/warehouseIntoAdd'
import warehouseOutAdd from '@/page/assignmentManage/warehouse/warehouseOutAdd'
import WarehouseIntoDetail from '@/page/assignmentManage/warehouse/WarehouseIntoDetail'
import bulkPracticingOfGoods from '@/page/assignmentManage/warehouse/bulkPracticingOfGoods'
import WarehouseIntoEdit from '@/page/assignmentManage/warehouse/WarehouseIntoEdit'
import WarehouseOutDetail from '@/page/assignmentManage/warehouse/WarehouseOutDetail'
import WarehouseOutEdit from '@/page/assignmentManage/warehouse/WarehouseOutEdit'
import GoodsAdd from '@/page/goodsManage/GoodsAdd'
import GoodsEdit from '@/page/goodsManage/GoodsEdit'
import NotVerify from '@/page/goodsManage/NotVerify'
import WarehousingDetai from '@/page/costMenu/WarehousingDetai'
import HandlingGoodsDetail from '@/page/costMenu/HandlingGoodsDetail'
import RunErrandsDetail from '@/page/costMenu/RunErrandsDetail'
import ReturnCostDetail from '@/page/costMenu/ReturnCostDetail'
import OtherCost from '@/page/costMenu/OtherCost' // 费用总表 - 其他费用
import OtherCostDetail from '@/page/costMenu/OtherCostDetail'
import warehouseOutPrinttemp from '@/page/assignmentManage/warehouseOutPrinttemp'
import warehousePickingPrinttemp from '@/page/assignmentManage/warehousePickingPrinttemp'
import warehouseIntoPrinttemp from '@/page/assignmentManage/warehouseIntoPrinttemp'
import billCheck from '@/page/billManage/billCheck'
import merchantInfo from '@/page/merchantManage/merchantInfo'
// import LiquidationTaskAdd from '@/page/liquidationManage/LiquidationTaskAdd'
import LiquidationTaskDetail from '@/page/liquidationManage/LiquidationTaskDetail'
import LiquidationLossDetail from '@/page/liquidationManage/LiquidationLossDetail'
import productionDateEntryDetail from '@/page/rollsHomework/productionDateEntry/productionDateEntryDetail'
import addPutawayList from '@/page/rollsHomework/putawayList/addPutawayList'
import putawayListDetail from '@/page/rollsHomework/putawayList/putawayListDetail'
import putawayPrintTemp from '@/page/rollsHomework/putawayList/putawayPrintTemp'
import addPlanGoods from '@/page/liquidationManage/addPlan/addPlanGoods'
import addPlanLocation from '@/page/liquidationManage/addPlan/addPlanLocation'
import liquidationPlan from '@/page/liquidationManage/liquidationPlan'
import liquidationPlanDetail from '@/page/liquidationManage/liquidationPlanDetail/'
import InventoryAdjustment from '@/page/inventoryManage/InventoryAdjustment'

import user from '../store/user/index'
import tagsView from '../store/tagsView'
import http from '../utils/http'
import processTree from '@/utils/processTree' // 处理最后一级数组为null
import { filterRoutes } from '@/utils/filterRoutes'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

Vue.use(Router)

// 解决vue-router在3.0版本以上重复点击菜单报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export let routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { isLoginPage: true }
  },
  {
    path: '/',
    name: '',
    component: Layout,
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
        meta: {
          title: '首页'
        }
      },
      {
        path: '/assignmentManage/warehouseintoadd/:warehouseCode',
        name: 'warehouseintoadd',
        component: warehouseIntoAdd,
        meta: {
          title: '新建入库任务',
          noCache: false
        }
      },
      {
        path: '/assignmentManage/warehouseoutadd/:warehouseCode',
        name: 'warehouseoutadd',
        component: warehouseOutAdd,
        meta: {
          title: '新建出库任务',
          noCache: false
        }
      },
      {
        path: '/assignmentManage/warehouseIntoEdit/:code/:nature(\\d+)/:taskType/:warehouseCode',
        name: 'warehouseIntoEdit',
        component: WarehouseIntoEdit,
        meta: {
          title: '出库-编辑',
          noCache: false
        }
      },
      {
        path: '/assignmentManage/warehouseOutEdit/:code/:nature',
        name: 'warehousequtedit',
        component: WarehouseOutEdit,
        meta: {
          title: '出库-编辑',
          noCache: false
        }
      },
      {
        path: '/assignmentManage/warehouseOutPrinttemp/:code/:mode/:nature',
        name: 'warehouseOutPrinttemp',
        component: warehouseOutPrinttemp,
        meta: {
          title: '打印出库单',
          noCache: true
        }
      },
      {
        path: '/assignmentManage/warehouseIntoPrinttemp/:code/:mode/:nature',
        name: 'warehouseIntoPrinttemp',
        component: warehouseIntoPrinttemp,
        meta: {
          title: '打印入库单',
          noCache: true
        }
      },
      {
        path: '/assignmentManage/warehousePickingPrinttemp/:code/:mode/:nature',
        name: 'warehousePickingPrinttemp',
        component: warehousePickingPrinttemp,
        meta: {
          title: '打印拣货单',
          noCache: true
        }
      },
      {
        path: '/assignmentManage/warehouseOutDetail/:code/:nature',
        name: 'warehouseOutDetail',
        component: WarehouseOutDetail,
        meta: {
          title: '出库-查看',
          noCache: false
        }
      },
      {
        path: '/assignmentManage/warehouseIntoDetail/:code/:nature',
        name: 'warehouseIntoDetail',
        component: WarehouseIntoDetail,
        meta: {
          title: '出库-查看',
          noCache: false
        }
      },
      {
        path: '/assignmentManage/warehouse/bulkPracticingOfGoods/:code/:nature',
        name: 'bulkPracticingOfGoods',
        component: bulkPracticingOfGoods,
        meta: {
          title: '批量练货',
          noCache: false
        }
      },
      {
        path: '/goodsmanage/goodsadd/:warehouseCode',
        name: 'goodsadd',
        component: GoodsAdd,
        meta: {
          title: '新增商品',
          noCache: false
        }
      },
      {
        path: '/goodsmanage/goodsedit/:type/:code/:warehouseCode',
        name: 'goodsedit',
        component: GoodsEdit,
        meta: {
          title: '编辑商品',
          noCache: false
        }
      },
      {
        path: '/goodsmanage/notverify',
        name: 'notverify',
        component: NotVerify,
        meta: {
          title: '未审商品',
          noCache: false
        }
      },
      {
        path: '/supplierManage/supplierset/:supplierCode/:supplierName/:warehouseCode',
        name: 'supplierset',
        component: SupplierSet,
        meta: {
          title: '费用配置',
          noCache: false
        }
      },
      {
        path: '/costmenu/warehousingdetai/:code/:computeType',
        name: 'warehousingdetai',
        component: WarehousingDetai,
        meta: {
          title: '仓储费-详情',
          noCache: false
        }
      },
      {
        path: '/costmenu/handlinggoodsdetail/:code/:money',
        name: 'handlinggoodsdetail',
        component: HandlingGoodsDetail,
        meta: {
          title: '装卸费-详情',
          noCache: false
        }
      },
      {
        path: '/costmenu/runErrandsdetail/:code/:money/:computeTypeName/:nature/:finishYocType',
        name: 'runerrandsdetail',
        component: RunErrandsDetail,
        meta: {
          title: '配送费-详情',
          noCache: false
        }
      },
      {
        path: '/costmenu/returncostdetail/:code/:money/:computeTypeName/:nature/:finishYocType',
        name: 'returncostdetail',
        component: ReturnCostDetail,
        meta: {
          title: '退货费-详情',
          noCache: false
        }
      },
      {
        path: '/costmenu/otherCost/:type/:code/:warehouseCode',
        name: 'othercost',
        component: OtherCost,
        meta: {
          title: '其他费用',
          noCache: false
        }
      },
      {
        path: '/costmenu/OtherCostDetail/:type/:code/:money',
        name: 'othercostdetail',
        component: OtherCostDetail,
        meta: {
          title: '其他费用详情',
          noCache: false
        }
      },
      {
        path: '/billManage/billCheck/:ybCode',
        name: 'billcheck',
        component: billCheck,
        meta: {
          title: '账单详情',
          noCache: false
        }
      },
      {
        path: '/merchantManage/merchantInfo',
        name: 'merchantInfo',
        component: merchantInfo,
        meta: {
          title: '商户信息',
          noCache: false
        }
      },
      // {
      //   path: '/liquidationManage/liquidationTaskAdd',
      //   name: 'liquidationTaskAdd',
      //   component: LiquidationTaskAdd,
      //   meta: {
      //     title: '新建盘点任务',
      //     noCache: false
      //   }
      // },
      {
        path: '/liquidationManage/liquidationTaskDetail/:code/:warehouseCode',
        name: 'liquidationTaskDetail',
        component: LiquidationTaskDetail,
        meta: {
          title: '盘点单详情',
          noCache: false
        }
      },
      {
        path: '/liquidationManage/liquidationLossDetail/:code/:warehouseCode',
        name: 'liquidationLossDetail',
        component: LiquidationLossDetail,
        meta: {
          title: '损益单详情',
          noCache: false
        }
      },
      {
        path: '/rollsHomework/productionDateEntry/productionDateEntryDetail/:taskCode/:status/:warehouseCode',
        name: 'productionDateEntryDetail',
        component: productionDateEntryDetail,
        meta: {
          title: '生产日期录入详情页',
          noCache: false
        }
      },
      {
        path: '/rollsHomework/putawayList/addPutawayList/:warehouseCode',
        name: 'addPutawayList',
        component: addPutawayList,
        meta: {
          title: '新增上架单',
          noCache: false
        }
      },
      {
        path: '/rollsHomework/putawayList/putawayListDetail/:code/:warehouseCode', // /rollsHomework/putawayList/putawayListDetail/G202108250011630483295467
        name: 'putawayListDetail',
        component: putawayListDetail,
        meta: {
          title: '上架单详情',
          noCache: false
        }
      },
      {
        path: '/rollsHomework/putawayList/putawayPrintTemp/:code/:mode/:warehouseCode', // /rollsHomework/putawayList/putawayListDetail/G202108250011630483295467
        name: 'putawayPrintTemp',
        component: putawayPrintTemp,
        meta: {
          title: '打印上架单',
          noCache: true
        }
      },
      {
        path: '/liquidationManage/liquidationPlan/addPlanGoods/:type/:warehouseCode', // 按商品、货位盘点
        name: 'addPlanGoods',
        component: addPlanGoods,
        meta: {
          title: '新建盘点计划',
          noCache: false
        }
      },

      {
        path: '/liquidationManage/liquidationPlan/addPlanLocation/:type/:warehouseCode', // 按货位盘点
        name: 'addPlanLocation',
        component: addPlanLocation,
        meta: {
          title: '新建盘点计划',
          noCache: false
        }
      },
      {
        path: '/liquidationManage/liquidationPlan',
        name: 'liquidationPlan',
        component: liquidationPlan,
        meta: {
          title: '盘点计划',
          noCache: false
        }
      },
      {
        path: '/liquidationManage/liquidationPlanDetail/:type/:code', // 盘点计划详情
        name: 'liquidationPlanDetail',
        component: liquidationPlanDetail,
        meta: {
          title: '盘点计划详情',
          noCache: false
        }
      },
      {
        path: '/inventoryManage/inventoryAdjustment',
        name: 'inventoryAdjustment',
        component: InventoryAdjustment,
        meta: {
          title: '库存调整单',
          noCache: false
        }
      }
    ]
  }
]

// 定义一个函数来创建router
const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  const token = localStorage.getItem('token')
  // 本地是否有token 有则已登录
  if (token) {
    if (to.meta.isLoginPage) { // 判断是否在登录页
      next({ path: '/' })
    } else {
      // 判断是否进入后台页面
      // if (to.path === '/agreement' ||
      //   to.path === '/privacy' || to.path === '/about' ||
      //   to.path === '/previewpdf') {
      //   next()
      // } else {
      // 动态挂在路由
      // console.log(user.state.userinfo.menuList, 'user.state.userinfo.menuList')
      if (!user.state.userinfo.menuList) {
        // 遮罩层
        // let loadingInstance = Loading.service({
        //   fullscreen: true,
        //   background: '#fff',
        //   text: '数据加载中，请稍候',
        //   spinner: 'el-icon-loading'
        // })
        // 获取用户信息
        let addRouters = []
        let params = {
          accout: localStorage.getItem('accout'),
          password: localStorage.getItem('password')
        }
        http.fetch('/api/user/getUserInfo', params).then(data => {
          if (data.success) {
            // 保存菜单到 vuex state
            user.state.userinfo = data.obj
            // 挂载页面
            addRouters = processTree(data.obj.menuList)
            // const menusMap = routes
            let newRoutes = filterRoutes(addRouters).menuRouters
            user.state.dataCenterPermis = []
            user.state.dataCenterPermis = filterRoutes(addRouters).dataCenterPermis
            // addRouters.map((v) => {
            //   // 一级菜单
            //   if (v.url && v.url !== null) {
            //     const { component } = v
            //     const item = {
            //       path: v.url,
            //       name: v.url.slice(v.url.lastIndexOf('/')),
            //       component: () => import(`@/page/${component}`),
            //       meta: {
            //         title: v.name
            //       }
            //     }
            //     menusMap[1].children.push(item)
            //   }
            //   // 二级菜单
            //   if (v.children) {
            //     v.children.map((vv) => {
            //       if (vv.url && vv.url !== null) {
            //         const { component } = vv
            //         const item = {
            //           path: vv.url,
            //           name: vv.url.slice(vv.url.lastIndexOf('/') + 1),
            //           component: () => import(`@/page/${component}`),
            //           meta: {
            //             title: vv.name
            //           }
            //         }
            //         menusMap[1].children.push(item)
            //       }
            //     })
            //   }
            // })
            newRoutes.push({ path: '*', redirect: '/', hidden: true })
            // console.log(newRoutes, 'menusMap')
            // 重置路由
            router.matcher = new Router({
              mode: 'history'
            }).matcher
            routes = [...routes, ...newRoutes]
            // console.log(routes, 'routes')
            router.addRoutes(routes)
            next({ ...to, replace: true })
            // 关闭遮罩层
            // loadingInstance.close()
          } else {
            // 关闭遮罩层
            // loadingInstance.close()
            localStorage.removeItem('token')
            tagsView.dispatch('tagsView/delAllViews')
            user.state.userinfo = {
              menuList: null
            }
            next({
              path: '/login'
            })
          }
        }
        )
      } else {
        // console.log('有路由菜单，进入了=======================')
        next()
      }
    }
  } else {
    // 没有登录，去跳转登录页
    if (to.path === '/login' || to.path === '/agreement' ||
      to.path === '/privacy' || to.path === '/about' ||
      to.path === '/previewpdf') {
      next()
    } else {
      next({
        path: '/login'
      })
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js